module.exports = __webpack_public_path__ + "img/solution14.9df22c3b.jpg";